import { render, staticRenderFns } from "./ARTableData.vue?vue&type=template&id=380b5a40&scoped=true"
import script from "./ARTableData.vue?vue&type=script&lang=js"
export * from "./ARTableData.vue?vue&type=script&lang=js"
import style0 from "./ARTableData.vue?vue&type=style&index=0&id=380b5a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380b5a40",
  null
  
)

export default component.exports